import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
var baseUri = "WebApi.asmx/api/iconListService";
const store = {};
const mutations = {
    SET_TOPICCARD_LIST(state, posts) {
        state.topicCardList = posts.list;
        state.topicCardListIsLoading = false;
        window.LoadPanel.Hide();
    },
};
const state = {
    topicCardListIsLoading: true,
    topicCardList: [],
};
const getters = {};
const actions = {
    getPresentationList({ commit }, params) {
        state.topicCardListIsLoading = true;
        axios
            .get(baseUri + '/GetPresentationList', { params: params})
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TOPICCARD_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}